var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTfcBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 11.6113 9.94629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 9.94629,
    opacity: 0,
    width: 11.6113,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6113 4.9707C11.6064 4.39941 10.8301 3.98438 9.89746 3.98438L7.92969 3.98438C7.65625 3.98438 7.55371 3.94043 7.39258 3.75488L4.11133 0.175781C4.00879 0.0585938 3.88184 0 3.73535 0L3.16895 0C3.04199 0 2.96875 0.112305 3.03223 0.249023L4.72168 3.98438L2.24121 4.26758L1.35742 2.64648C1.29395 2.52441 1.18652 2.4707 1.02539 2.4707L0.81543 2.4707C0.688477 2.4707 0.605469 2.55371 0.605469 2.68066L0.605469 7.26074C0.605469 7.3877 0.688477 7.46582 0.81543 7.46582L1.02539 7.46582C1.18652 7.46582 1.29395 7.41211 1.35742 7.29492L2.24121 5.67383L4.72168 5.95703L3.03223 9.69238C2.96875 9.82422 3.04199 9.94141 3.16895 9.94141L3.73535 9.94141C3.88184 9.94141 4.00879 9.87793 4.11133 9.76562L7.39258 6.18164C7.55371 6.00098 7.65625 5.95703 7.92969 5.95703L9.89746 5.95703C10.8301 5.95703 11.6064 5.53711 11.6113 4.9707Z",
    fill: "#167ce1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTfcBlue);
export default __webpack_public_path__ + "static/media/tfcBlue.ad3bc8fa2a15976186789b3872a970e3.svg";
export { ForwardRef as ReactComponent };